import type { ReactNode } from "react";

/** Wraps every case-insensitive occurrence of `query` with a yellow highlight. */
export function highlightMatch(text: string, query: string): ReactNode {
  const q = query.trim();
  if (!q || !text) return text;
  const escaped = q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = text.split(new RegExp(`(${escaped})`, "gi"));
  if (parts.length === 1) return text;
  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <mark
            key={i}
            className="rounded-sm bg-yellow-200 px-0.5 text-yellow-900 not-italic"
          >
            {part}
          </mark>
        ) : (
          part || null
        )
      )}
    </>
  );
}
